/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, February 2022
 * @flow
 */

import React from 'react';
import Header from '../Header';
import CheckList from '../CheckList';
import CheckDetails from '../CheckDetails';
import Notifications from '../../../Fireboard/components/Body/Notifications';
import classes from './Body.module.css';
import modeEnums from '../../../../enums/modeEnums';

const Body = props => {
  const {
    goBack,
    parentRoute,
    checkList,
    onSelectCheck,
    selectedCheck,
    showPopup,
    currentMode,
    onClickCheckFooterButton,
    checkFilters,
    iso2,
    currency,
    onRequestRefreshGuestGPS,
    showMemberDetailPopup,
    items,
    pendingItems,
    onPrintPress,
    sortByName,
    ascending,
    onChangeSortBy,
    onChangeSorting,
    checkSortFunction,
    checkIdsMap,
    notificationsData,
    removeNewTag,
    showNotifications,
    setNotifications,
    notificationControlEnabled,
    snoozeEnabled,
    snoozeNotifications,
    notificationCount,
    totalNotificationsCount,
    onClickSms,
    sensorsMap,
    openCaptureSeatNamePopup,
    enableAgeRestrictedOrderingForSeat,
    onUpdateAgeRestrictedItemsForSeat,
    sendPendingItems,
    enableAgeVerification,
    enableAgeRestrictedOrderingForCheck,
  } = props;
  const showBack = currentMode === modeEnums.TABLE_DELIVERY ? true : parentRoute === 'fireboard';

  const renderContent = () => {
    if (showNotifications) {
      return (
        <Notifications
          notificationsData={notificationsData}
          removeNewTag={removeNewTag}
        />
      );
    }

    return (
      <React.Fragment>
        <CheckList
          checkList={checkList}
          onSelectCheck={onSelectCheck}
          selectedCheck={selectedCheck}
          showPopup={showPopup}
          currentMode={currentMode}
          onClickCheckFooterButton={onClickCheckFooterButton}
          checkFilters={checkFilters}
          checkSortFunction={checkSortFunction}
          ascending={ascending}
          checkIdsMap={checkIdsMap}
          sensorsMap={sensorsMap}
        />
        <CheckDetails
          selectedCheck={selectedCheck}
          iso2={iso2}
          currency={currency}
          showPopup={showPopup}
          onRequestRefreshGuestGPS={onRequestRefreshGuestGPS}
          showMemberDetailPopup={showMemberDetailPopup}
          items={items}
          pendingItems={pendingItems}
          onPrintPress={onPrintPress}
          onClickSms={onClickSms}
          openCaptureSeatNamePopup={openCaptureSeatNamePopup}
          enableAgeRestrictedOrderingForSeat={enableAgeRestrictedOrderingForSeat}
          onUpdateAgeRestrictedItemsForSeat={onUpdateAgeRestrictedItemsForSeat}
          sendPendingItems={sendPendingItems}
          enableAgeVerification={enableAgeVerification}
          enableAgeRestrictedOrderingForCheck={enableAgeRestrictedOrderingForCheck}
        />
      </React.Fragment>
    )
  };

  return (
    <div className={classes.bodyContainer}>
      <Header
        showBack={showBack}
        goBack={goBack}
        sortByName={sortByName}
        ascending={ascending}
        onChangeSortBy={onChangeSortBy}
        onChangeSorting={onChangeSorting}
        showNotifications={showNotifications}
        setNotifications={setNotifications}
        notificationControlEnabled={notificationControlEnabled}
        snoozeEnabled={snoozeEnabled}
        snoozeNotifications={snoozeNotifications}
        notificationCount={notificationCount}
        totalNotificationsCount={totalNotificationsCount}
      />
      <div className={classes.contentWrapper}>
        {renderContent()}
      </div>
    </div>
  );
};

export default Body;
